import React, { useState } from 'react';
import { Modal } from 'antd';
import ButtonLink from './ButtonLink';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Title from 'components/Title';

type ModalSFSProps = {
  trigger: (params: {
    setVisible: (visible: boolean) => void;
  }) => React.ReactNode;
  modalProps?: Omit<React.ComponentProps<typeof Modal>, 'open' | 'onCancel'>;
  children: React.ReactNode;
  prevLabel?: string;
  nextLabel?: string;
  title?: string
  footer?: boolean
  width?: number|string;
  hideCloseButton?:boolean
  className?:string;
};

const ModalSFS: React.FC<ModalSFSProps> = ({
  trigger,
  modalProps = {},
  children,
  prevLabel,
  nextLabel,
  title,
  footer, 
  width,
  hideCloseButton,
  className
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      {trigger({ setVisible })}

      <Modal
        open={visible}
        onCancel={hideCloseButton&&hideCloseButton?undefined:() => setVisible(false)}
        destroyOnClose
        footer={null}
        title={
          prevLabel ? (
            <div className='d-flex align-items-center mt-4 mb-4 ml-2 mr-2'>
              <Title level={3} className='mb-0 line-height-normal mr-1 font-weight-500' comcode={title ?? ""} /> <h3 className="ant-typography  css-dev-only-do-not-override-9sfe50 css-var-r1 font-size-24 font-weight-500 mt-0 line-height-normal"> {prevLabel}</h3>
            </div>
          ) : (
            <Title level={3} comcode={title ?? ""} className='font-weight-500 ml-2 mr-2' />
          )
        }
                {...modalProps}
        className={ `modal-sfs ${className}`}
        width={width}
      >
        {React.cloneElement(children as React.ReactElement, { setVisible })}

      </Modal>
    </>
  );
};

export default ModalSFS;
